<template>
  <button type="submit">{{ buttonText }}</button>
</template>

<script>
export default {
  name: "AppSubmitBtn",
  props: {
    text: String
  },
  computed: {
    buttonText() {
      return this.text;
    }
  }
};
</script>

<style scoped>
button {
  text-align: center;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  padding: 0.8rem 1.4rem;
  width: fit-content;
  transition: background-color 0.3s ease-out;
  user-select: none;
}

button:disabled {
  pointer-events: none;
  background-color: rgba(46, 46, 46, 0.4) !important;
}
</style>
